import { createFileRoute } from '@tanstack/react-router'
import Homepage from '@/components/Homepage'
import UmbrellaHomeV5 from '@/components/umbrella/UmbrellaHomeV5'
import DcucHome from '@/components/dcuc/DcucHome'
import AmbaHome from '@/components/amba/AmbaHome'
import GranGuardHome from '@/components/granguard/GranGuardHome'
import BeekeeperHome from '@/components/granguard/BeekeeperHome'
import { COMMUNITY_PARTNER } from '@/lib/community-partners'
import QatarHome from '@/components/qatar/QatarHome'
import { resolveSite } from '@/lib/site'

export const Route = createFileRoute('/')({
  component: IndexRoute,
})

function IndexRoute() {
  // Apex (scamdefense.org) shows the umbrella platform pitch; the NASAA states
  // build is reached on nasaa.scamdefense.org; the DCUC military pitch on
  // dcuc.scamdefense.org; the AMBA military-banking pitch on
  // amba.scamdefense.org; the ungated GranGuard face for older adults on
  // granguard.scamdefense.org (or via ?site=).
  switch (resolveSite()) {
    case 'nasaa':
      return <Homepage />
    case 'dcuc':
      return <DcucHome />
    case 'amba':
      return <AmbaHome />
    case 'granguard':
      return COMMUNITY_PARTNER?.slug === 'beekeeper' ? <BeekeeperHome /> : <GranGuardHome />
    case 'qatar':
      return <QatarHome />
    default:
      // The v5 rebuild (2026-07-28): slicksheet narrative with the classic
      // particle hero. /home-v5 renders the same component for QA.
      return <UmbrellaHomeV5 />
  }
}
